import React from 'react'
import classes from "./Loader.module.css"
import spinner from "./spinner.gif";

function Loader() {
return (
    <div className={classes.loader__wrapper}>
<img src={spinner} alt="loading..." />
</div>
);

}

export default Loader;